var map = {
	"./assets/brand/brandmark.svg": "0701",
	"./assets/brand/horizontal.svg": "c68f",
	"./assets/css/index.css": "a2f0",
	"./assets/helpers": "4edf",
	"./assets/helpers.ts": "4edf",
	"./assets/images/404.png": "3dfc",
	"./assets/images/Captain_Pependle.png": "8a5f",
	"./assets/images/Peepo.png": "f4da",
	"./assets/images/brand/meta-bg.jpg": "30fd",
	"./assets/images/coins/DAI.png": "dae8",
	"./assets/images/coins/ETH.png": "0238",
	"./assets/images/coins/ETH_logo.png": "6f34",
	"./assets/images/coins/USDC.svg": "68b6",
	"./assets/images/coins/USDT.png": "2e7c",
	"./assets/images/coins/acrv_ot.svg": "bf7b",
	"./assets/images/coins/acrv_yt.svg": "1136",
	"./assets/images/coins/ausdc.svg": "93d2",
	"./assets/images/coins/ausdc_ot.svg": "0220",
	"./assets/images/coins/ausdc_yt.svg": "b366",
	"./assets/images/coins/ausdt_ot.svg": "3a43",
	"./assets/images/coins/ausdt_yt.svg": "37ae",
	"./assets/images/coins/avalanche.svg": "246f",
	"./assets/images/coins/avalanche/avax.png": "9d58",
	"./assets/images/coins/avalanche/joe-avaxusdc.png": "8bd7",
	"./assets/images/coins/avalanche/joe-pa.png": "9736",
	"./assets/images/coins/avalanche/joe.png": "f3fd",
	"./assets/images/coins/avalanche/mim.png": "2d03",
	"./assets/images/coins/avalanche/ot-avaxusdc_usdc.png": "4e2c",
	"./assets/images/coins/avalanche/ot-joe-avaxusdc.png": "ac43",
	"./assets/images/coins/avalanche/ot-joe-pa.png": "802b",
	"./assets/images/coins/avalanche/ot-pa_pendle.png": "30e4",
	"./assets/images/coins/avalanche/ot-qiavax.png": "6add",
	"./assets/images/coins/avalanche/ot-qiavax_usdc.png": "88ab",
	"./assets/images/coins/avalanche/ot-qiusdc.png": "fbf9",
	"./assets/images/coins/avalanche/ot-qiusdc_usdc.png": "509b5",
	"./assets/images/coins/avalanche/ot-wmemo.png": "e624",
	"./assets/images/coins/avalanche/ot-wmemo_mim.png": "b22d",
	"./assets/images/coins/avalanche/ot-xjoe.png": "cfe0",
	"./assets/images/coins/avalanche/ot-xjoe_usdc.png": "497f",
	"./assets/images/coins/avalanche/qi.png": "4fa6",
	"./assets/images/coins/avalanche/qiavax.png": "91fc",
	"./assets/images/coins/avalanche/qiusdc.png": "a400",
	"./assets/images/coins/avalanche/time.png": "6449",
	"./assets/images/coins/avalanche/usdt.png": "b006",
	"./assets/images/coins/avalanche/wavax.png": "34e4",
	"./assets/images/coins/avalanche/wbtc.png": "00ba",
	"./assets/images/coins/avalanche/weth.png": "d367",
	"./assets/images/coins/avalanche/wmemo.png": "e9bf",
	"./assets/images/coins/avalanche/xjoe.png": "0121",
	"./assets/images/coins/avalanche/yt-avaxusdc_usdc.png": "9008",
	"./assets/images/coins/avalanche/yt-joe-avaxusdc.png": "34cd",
	"./assets/images/coins/avalanche/yt-joe-pa.png": "3211",
	"./assets/images/coins/avalanche/yt-pa_pendle.png": "0466",
	"./assets/images/coins/avalanche/yt-qiavax.png": "cf7c",
	"./assets/images/coins/avalanche/yt-qiavax_usdc.png": "37d3",
	"./assets/images/coins/avalanche/yt-qiusdc.png": "cb0f",
	"./assets/images/coins/avalanche/yt-qiusdc_usdc.png": "1609",
	"./assets/images/coins/avalanche/yt-wmemo.png": "8e1e",
	"./assets/images/coins/avalanche/yt-wmemo_mim.png": "3830",
	"./assets/images/coins/avalanche/yt-xjoe.png": "9693",
	"./assets/images/coins/avalanche/yt-xjoe_usdc.png": "efeb",
	"./assets/images/coins/cdai.svg": "3171",
	"./assets/images/coins/cdai_ot.svg": "5224",
	"./assets/images/coins/cdai_yt.svg": "ef67",
	"./assets/images/coins/comp.svg": "a638",
	"./assets/images/coins/cusdt_ot.svg": "9fcf",
	"./assets/images/coins/cusdt_yt.svg": "082e",
	"./assets/images/coins/lp-pendleeth.svg": "d6f5",
	"./assets/images/coins/mainnet/ot-ausdc.png": "e83f",
	"./assets/images/coins/mainnet/ot-cdai.png": "2fd1",
	"./assets/images/coins/mainnet/ot-ethusdc.png": "c13a",
	"./assets/images/coins/mainnet/ot-ethusdc_usdc.png": "d8a8",
	"./assets/images/coins/mainnet/ot-pe.png": "a173",
	"./assets/images/coins/mainnet/ot-pe_pendle.png": "4382",
	"./assets/images/coins/mainnet/ot-wxbtrfly.png": "258e",
	"./assets/images/coins/mainnet/ot-wxbtrfly_usdc.png": "936b",
	"./assets/images/coins/mainnet/slp-ethusdc.png": "88f2",
	"./assets/images/coins/mainnet/slp-pe.png": "e056",
	"./assets/images/coins/mainnet/wxbtrfly.png": "c7b9",
	"./assets/images/coins/mainnet/yt-ausdc.png": "2a76",
	"./assets/images/coins/mainnet/yt-cdai.png": "b377",
	"./assets/images/coins/mainnet/yt-ethusdc.png": "d593",
	"./assets/images/coins/mainnet/yt-ethusdc_usdc.png": "fb41",
	"./assets/images/coins/mainnet/yt-pe.png": "581f",
	"./assets/images/coins/mainnet/yt-pe_pendle.png": "8192",
	"./assets/images/coins/mainnet/yt-wxbtrfly.png": "aa6e",
	"./assets/images/coins/mainnet/yt-wxbtrfly_usdc.png": "2e5d",
	"./assets/images/coins/ot-ausdc_usdc.png": "66bf",
	"./assets/images/coins/ot-cdai_usdc.png": "04dc",
	"./assets/images/coins/ot-pendle_eth_slp.svg": "9904",
	"./assets/images/coins/ot-slp_eth_usdc-usdc.png": "4f68",
	"./assets/images/coins/ot-slp_pendle_eth-usdc.png": "d9d0",
	"./assets/images/coins/ot-usdc_eth_slp.svg": "6b88",
	"./assets/images/coins/pendle-eth-lp.svg": "a95a",
	"./assets/images/coins/pendle.png": "227f",
	"./assets/images/coins/pendle.svg": "3c22",
	"./assets/images/coins/slp_eth_usdc.svg": "6a91",
	"./assets/images/coins/slp_pendle_eth.svg": "3276",
	"./assets/images/coins/stkaave.svg": "b30f",
	"./assets/images/coins/sushi.svg": "bcb3",
	"./assets/images/coins/yt-ausdc_usdc.png": "ffd9",
	"./assets/images/coins/yt-cdai_usdc.png": "85e2",
	"./assets/images/coins/yt-eth_usdc_slp.svg": "e48c",
	"./assets/images/coins/yt-pendle_eth_slp.png": "8df1",
	"./assets/images/coins/yt-pendle_eth_slp.svg": "71560",
	"./assets/images/coins/yt-slp_eth_usdc-usdc.png": "4ee4",
	"./assets/images/coins/ytslp_pendle_eth-pendle.png": "bf71",
	"./assets/images/error-icon.svg": "e0dd",
	"./assets/images/leaderboard_banner.png": "d8d8",
	"./assets/images/starry_window.png": "f0c9",
	"./assets/images/unknown.png": "f087",
	"./assets/logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";